import TableCell from 'Components/Common/components/TableCell';
import React, { useEffect, useState } from 'react';
import { getAllLogs } from '../ARSServices/ARSServices';
import { CSSTransition } from "react-transition-group";
import { formatDate } from './HelperClass';
import ARSLogs from '../ARSLogs';
import TableSkeletonElement from 'Components/GMS/Products/components/TableSkeletonElement';
import NoDataComponent from 'Components/Common/NoDataComponent';

type HistoryTableProps = {
    merchantId: string;
}

const HIstoryTable = ({ merchantId }: HistoryTableProps) => {
    const [logs, setLogs] = useState<ArsLogsResponse[]>([]);
    const [showLogs, setShowLogs] = useState<boolean>(false);
    const [selectedLog, setSelectedLog] = useState<ArsLogsResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getMerchantLogs();
    }, [merchantId]);

    const getMerchantLogs = async () => {
        setLoading(true);
        const res = await getAllLogs(merchantId);
        if (res?.done) {
            const logs = res?.data ?? [];
            setLogs(logs);
        }
        setLoading(false);
    }

    const handleSelectLog = (log: ArsLogsResponse) => {
        setSelectedLog(log);
        setShowLogs(true);
    }

    return (
        <>
            {loading ? <TableSkeletonElement /> : null}
            {!loading && logs?.length === 0 ? <NoDataComponent /> : !loading ? <div id="logs-table-container" className="tw-border tw-border-solid tw-rounded tw-mt-3 tw-border-[#DFE0E6] tw-border-r-2 ">
                <div id="logs-scroll-container" className="table-container tw-rounded" style={{ width: '100%', height: '600px', overflowX: 'auto' }}>
                    <table id="logs-table" className="tw-bg-[#DFE1E6] tw-w-full">
                        <thead id="logs-table-header" className="tw-sticky tw-top-0 tw-bg-[#DFE1E6]">
                            <tr>
                                <th id="model-header" className="table-header-style">MODEL NAME</th>
                                <th id="type-header" className="table-header-style">TYPE</th>
                                <th id="started-by-header" className="table-header-style">STARTED BY</th>
                                <th id="started-at-header" className="table-header-style">STARTED AT</th>
                                <th id="status-header" className="table-header-style">STATUS</th>
                                <th id="time-taken-header" className="table-header-style">TIME TAKEN</th>
                                <th id="actions-header" className="table-header-style"></th>
                            </tr>
                        </thead>
                        <tbody id="logs-table-body" className="tw-bg-white tw-divide-y tw-divide-[#F4F5F7]">
                            {logs.map((row, rowIndex) => {
                                return <tr id={`log-row-${rowIndex}`} key={row?.uid}>
                                    <TableCell id={`model-${rowIndex}`} rowIndex={rowIndex} >
                                        <div id={`model-text-${rowIndex}`} className='tw-truncate'>{row?.model_name ?? '-'}</div>
                                    </TableCell>
                                    <TableCell id={`type-${rowIndex}`} rowIndex={rowIndex}>
                                        <div id={`type-text-${rowIndex}`} className="tw-text-[#090942] tw-text-sm tw-font-normal tw-leading-relaxed">
                                            {row?.type ?? ''}
                                        </div>
                                    </TableCell>
                                    <TableCell id={`started-by-${rowIndex}`} rowIndex={rowIndex}>
                                        <div id={`started-by-text-${rowIndex}`} className="tw-text-[#090942] tw-text-sm tw-font-normal tw-leading-relaxed">
                                            {row?.user_name}
                                        </div>
                                    </TableCell>
                                    <TableCell id={`started-at-${rowIndex}`} rowIndex={rowIndex}>
                                        <div id={`started-at-text-${rowIndex}`} className="tw-text-[#090942] tw-text-sm tw-font-normal tw-leading-relaxed">
                                            {formatDate(row?.created_at)}
                                        </div>
                                    </TableCell>
                                    <TableCell id={`status-${rowIndex}`} rowIndex={rowIndex} onClick={() => { }}>
                                        <div id={`status-text-${rowIndex}`} className="tw-text-[#090942] tw-text-sm tw-font-normal tw-leading-relaxed">
                                            {row?.status ?? ''}
                                        </div>
                                    </TableCell>
                                    <TableCell id={`time-taken-${rowIndex}`} rowIndex={rowIndex}>
                                        <div id={`time-taken-text-${rowIndex}`} className="tw-text-[#090942] tw-text-sm tw-font-normal tw-leading-relaxed">
                                            {row?.completed_time ?? ''}
                                        </div>
                                    </TableCell>
                                    <TableCell id={`actions-${rowIndex}`} rowIndex={rowIndex}>
                                        <button
                                            id={`view-logs-btn-${rowIndex}`}
                                            type="button"
                                            className="tw-p-0 tw-bg-transparent tw-border-0 tw-text-primary"
                                            onClick={() => handleSelectLog(row)}
                                        >
                                            View Logs
                                        </button>
                                    </TableCell>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div> : null}
            {showLogs ? (
                <CSSTransition timeout={1000} classNames={{ enterActive: "animate__animated animate__flipInX", exitActive: "animate__animated animate__flipOutX", }}>
                    {selectedLog != null && <ARSLogs
                        id={selectedLog?.uid}
                        model_id={selectedLog?.model_id}
                        setShowLogs={setShowLogs}
                        setSelectedLog={setSelectedLog}
                    />}
                </CSSTransition>
            ) : null}
        </>
    );
}

export default HIstoryTable;